<template>
  <v-dialog
    :value="show"
    persistent
    max-width="750px"
    transition="dialog-transition"
    @input="$emit('close')"
  >
    <v-card>
      <v-card-title>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap>
            <v-flex xs12>
              <h2>
                Enviar conversacion
              </h2>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap py-2>
            <v-flex>
              <v-select
                v-model="form.company_email_id"
                :items="emails"
                item-value="id"
                item-text="name"
                v-validate="'required|numeric'"
                data-vv-name="company_email_id"
                data-vv-as="email"
                :error-messages="errors.collect('company_email_id')"
                label="Email"
                color="black">
                <template slot="item" slot-scope="item">
                  {{ item.item.from_name }}
                  <small class="ml-2"><{{ item.item.email }}></small>
                </template>
                <template slot="selection" slot-scope="selection">
                  {{ selection.item.from_name }}
                  <small class="ml-2"><{{ selection.item.email }}></small>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex shrink>
            <v-btn flat color="black" @click="$emit('close')">
              CANCELAR
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn class="k-orange-linear-text" flat @click="send">
              ENVIAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        company_email_id: '',
      },
      emails: [],
    };
  },
  methods: {
    send() {
      this.axios.post(`/chat_center/conversation/send/${this.selected}`, {
        company_email_id: this.form.company_email_id,
      }).then(({ data }) => {
        if (data.code === 200) {
          this.$emit('saved');
        }
      });
    },
  },
  watch: {
    show(value) {
      if (value && !this.emails.length) {
        this.axios
          .get('v2/company_emails')
          .then(({ data }) => {
            this.emails = data;
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/chat_center_v2/SendConversationModal.vue